import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export const useTopLevelPage = () => {
  const location = useLocation();
  const { port } = useParams();
  const regex = useMemo(() => RegExp(port && port.length ? `/[^/]*/${port}/([^/]*)` : `/[^/]*/([^/]*)`), [port]);
  return useMemo(() => regex.exec(location.pathname)![1].toLowerCase(), [regex, location]);
}